import React from 'react';
import { useNavigate } from 'react-router-dom';
import MomentumLogo from '../../assets/images/momentum-ai-logo.png';
import '../../assets/css/Hub.css';

export default function AMPHeader() {
  const navigate = useNavigate();

  const handleSettingsClick = () => {
    navigate('/settings');
  };
  function generateGuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }


  return (
    <header className="amp-header end-0 start-0 border-bottom bg-white px-3 py-2 d-flex align-items-center">
      <div className="hub-logo-section" style={{ paddingRight: '32px' }}>
        <div className="hub-logo-icon" style={{ width: '170px', height: '44px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }} onClick={() => navigate(`/supportbot/${generateGuid()}`)}>
          <img src={MomentumLogo} alt="Momentum Logo" style={{ width: '160px', height: '40px', objectFit: 'contain' }} />
        </div>
      </div>
    </header>
  );
}
